import { useFilters } from '../../contexts/FilterContext'
import HealthFacilityModal from './HealthFacilityModal'
import EducationFacilityModal from './EducationFacilityModal'

function FacilityModalWrapper() {
  const { activeCategory } = useFilters()

  // Render the appropriate modal based on the active category
  switch (activeCategory) {
    case 'health':
      return <HealthFacilityModal />
    case 'education':
      return <EducationFacilityModal />
    default:
      // Fallback to health modal for unknown categories
      return <HealthFacilityModal />
  }
}

export default FacilityModalWrapper
